/**
 * Suggestion priority, Tier 1: Getting Started first (CINCHAI-135; native-cinch-ai-self-driving-marketing.md
 * §2). The chat reads the company's Getting Started steps from the Action Items service and sends
 * `{remaining, total, declined}` with each turn; the proxy makes the next step the agent's first offer.
 */

// The titles the Action Items page shows (pages/action-items/action-items.component.js).
export const STEP_TITLES = {
  'company_setup': 'Company setup',
  'users_roles': 'Users & roles',
  'data_integration': 'Data integration',
  'oil_change_calculator': 'Oil change calculator',
  'data_fields': 'Data fields',
  'location_setup': 'Location data',
  'brand_guides': 'Brand guidelines',
  '10dlc': '10DLC registration',
  'domain_verification': 'Domain verification',
  'journeys': 'Journeys',
  'reviews_setup': 'Reviews',
  'google_business_profile': 'Google Business Profile',
  'surveys_setup': 'Surveys',
  'voice_agent_setup': 'AI Voice agent',
  'scheduler_setup': 'Scheduler'
};

// Still to do: never started, waiting on someone (pending) or failed. Done and skipped steps are not.
const OPEN = new Set(['not_started', 'pending', 'error']);
export const DECLINED_MEMORY = 'getting-started-declined';
export const DECLINE_DAYS = 7;
const titleOf = key => STEP_TITLES[key] || key.replace(/_/g, ' ').replace(/^./, c => c.toUpperCase());

/** `{remaining: [{key, title}], total}` from the action items response; steps hidden for the company ('ignored') don't count. */
export function gettingStartedFrom(data) {
  const steps = (data?.getting_started_steps || []).filter(step => step?.key && step.status !== 'ignored');
  return {
    remaining: steps.filter(step => OPEN.has(step.status)).map(step => ({
      key: step.key,
      title: titleOf(step.key)
    })),
    total: steps.length
  };
}

/** `{stepKey: status}` for every step in the response, 'ignored' included (CINCHAI-146's suggestions use it). */
export function stepStatusesFrom(data) {
  return Object.fromEntries((data?.getting_started_steps || []).filter(step => step?.key).map(step => [step.key, step.status]));
}

/** Whether the user declined an offer in the last 7 days (the personal memory's last update). */
export function declinedRecently(memory, now = Date.now()) {
  const when = memory?.updated_when ? new Date(memory.updated_when).getTime() : NaN;
  return Number.isFinite(when) && now - when < DECLINE_DAYS * 24 * 60 * 60 * 1000;
}